module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-cake-22ebfd22ba3f96f6410b2ff6b2494e83.png";